"use strict";
var spider = document.querySelector(".spider");
document.addEventListener("click", function(e) {
    var wall = e.target.closest(".wall");
    if (!wall) return;
    var wallRect = wall.getBoundingClientRect();
    var rawX = e.clientX - wallRect.left - wall.clientLeft - spider.offsetWidth / 2;
    var rawY = e.clientY - wallRect.top - wall.clientTop - spider.offsetHeight / 2;
    var maxX = wall.clientWidth - spider.offsetWidth;
    var maxY = wall.clientHeight - spider.offsetHeight;
    var x = Math.min(Math.max(rawX, 0), maxX);
    var y = Math.min(Math.max(rawY, 0), maxY);
    spider.style.left = "".concat(x, "px");
    spider.style.top = "".concat(y, "px");
});

//# sourceMappingURL=index.c31c384a.js.map
